import { type DeepReadonly, inject, provide, type Ref } from 'vue';

export type SelectContext = {
  dataTestid?: DeepReadonly<Ref<string | undefined>>;
  id?: DeepReadonly<Ref<string | undefined>>;
};

export const SELECT_CONTEXT_KEY = Symbol();

export const provideSelectContext = (context: SelectContext) =>
  provide(SELECT_CONTEXT_KEY, context);

export const injectSelectContext = () =>
  inject<SelectContext | undefined>(SELECT_CONTEXT_KEY, undefined);
